import { getNodes } from '@/utils/graphql'

/**
 * Takes a relay object and returns the nodes, memoized
 * @param data An object containing edges
 */
export function useNodes<T>(
  data:
    | { edges?: ({ node?: T | null | undefined } | null)[] | null | undefined }
    | undefined,
  filter?: (node: T) => boolean
) {
  return getNodes(data, filter)
}
